var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrayonIQLogosNegativeSamIQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 781.36 378.32",
    style: {
      enableBackground: "new 0 0 781.36 378.32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 450.81,
    y: 195.4,
    className: "st0",
    width: 12.82,
    height: 15.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M597.3,145.77c-17.82,0-36.93,12.05-36.93,38.71S579.48,223,597.3,223c4.31,0,8.63-0.74,12.99-2.18 l-18.74-20.5l18.89-15.85l18.74,20.53c3.06-5.6,4.87-12.24,4.87-20.53C634.04,157.82,614.96,145.77,597.3,145.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.59,184.66c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61 c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85l-15.68-17.1 C658.16,216.14,663.59,201.77,663.59,184.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.59,184.66c0-40.51-30.43-66.61-66.29-66.61c-36.04,0-66.48,26.1-66.48,66.61 c0,40.33,30.43,66.43,66.48,66.43c11.88,0,23.42-2.88,33.13-8.29l15.68,17.29l18.74-15.85l-15.68-17.1 C658.16,216.14,663.59,201.77,663.59,184.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.33,87.34V195.4h13.81v15.9h-13.81v79.69h224.65V87.34H468.33z M520.52,247.07h-23.54v-52.13h23.54V247.07 z M520.52,183.17h-23.54v-23.54h23.54V183.17z M646.1,260.08l-15.68-17.29c-9.7,5.42-21.25,8.29-33.13,8.29 c-36.04,0-66.48-26.1-66.48-66.43c0-40.51,30.43-66.61,66.48-66.61c35.86,0,66.29,26.1,66.29,66.61c0,17.1-5.42,31.48-14.42,42.47 l15.68,17.1L646.1,260.08z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.67,216.58h16.14c0.54,10.94,10.94,22.06,27.44,22.06c16.14,0,24.93-10.04,24.93-20.98 c0-12.02-10.94-17.4-21.34-20.09l-15.96-3.95c-26.18-6.28-30.31-21.7-30.31-31.74c0-21.34,19.19-34.97,40.71-34.97 c21.7,0,39.1,13.81,39.1,35.87h-16.14c0-12.37-10.22-20.8-23.49-20.8c-12.37,0-23.85,7.53-23.85,19.73 c0,4.3,1.43,13.27,17.93,17.22l16.14,3.95c20.98,5.2,33.54,16.68,33.54,34.25c0,19.19-15.6,36.58-41.25,36.58 C105.24,253.7,87.85,235.77,87.67,216.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.2,220.16h-53.08l-12.02,31.74h-17.04l46.99-123.56h17.22l46.99,123.56h-17.04L253.2,220.16z  M247.82,205.82l-21.16-55.95l-21.16,55.95H247.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.68,251.91l-11.48-94.15l-39.27,80.7h-14.17l-39.63-80.7l-11.3,94.15h-15.96l15.06-123.56h14.71 l44.12,91.64l43.94-91.64h14.71l15.24,123.56H415.68z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrayonIQLogosNegativeSamIQ);
export default __webpack_public_path__ + "static/media/Crayon_iQ_logos_negative_SAM_iQ.c4749e4e19c26d73ee19a723131ad192.svg";
export { ForwardRef as ReactComponent };